/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SetPasswordRouteImport } from './routes/set-password'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppTradesRouteImport } from './routes/_app/trades'
import { Route as AppStatementsRouteImport } from './routes/_app/statements'
import { Route as AppStaffRouteImport } from './routes/_app/staff'
import { Route as AppSettlementRouteImport } from './routes/_app/settlement'
import { Route as AppSecurityRouteImport } from './routes/_app/security'
import { Route as AppRiskRouteImport } from './routes/_app/risk'
import { Route as AppRevenueRouteImport } from './routes/_app/revenue'
import { Route as AppReconciliationRouteImport } from './routes/_app/reconciliation'
import { Route as AppPositionsRouteImport } from './routes/_app/positions'
import { Route as AppPayoutsRouteImport } from './routes/_app/payouts'
import { Route as AppOrganizationRouteImport } from './routes/_app/organization'
import { Route as AppInvitationsRouteImport } from './routes/_app/invitations'
import { Route as AppHierarchyRouteImport } from './routes/_app/hierarchy'
import { Route as AppFundingRouteImport } from './routes/_app/funding'
import { Route as AppUsersIndexRouteImport } from './routes/_app/users.index'
import { Route as AppOrdersIndexRouteImport } from './routes/_app/orders.index'
import { Route as AppFeesIndexRouteImport } from './routes/_app/fees.index'
import { Route as AppUsersAccountIdRouteImport } from './routes/_app/users.$accountId'
import { Route as AppOrdersHistoryRouteImport } from './routes/_app/orders.history'
import { Route as AppFeesPlansRouteImport } from './routes/_app/fees.plans'

const SetPasswordRoute = SetPasswordRouteImport.update({
  id: '/set-password',
  path: '/set-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppTradesRoute = AppTradesRouteImport.update({
  id: '/trades',
  path: '/trades',
  getParentRoute: () => AppRoute,
} as any)
const AppStatementsRoute = AppStatementsRouteImport.update({
  id: '/statements',
  path: '/statements',
  getParentRoute: () => AppRoute,
} as any)
const AppStaffRoute = AppStaffRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => AppRoute,
} as any)
const AppSettlementRoute = AppSettlementRouteImport.update({
  id: '/settlement',
  path: '/settlement',
  getParentRoute: () => AppRoute,
} as any)
const AppSecurityRoute = AppSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => AppRoute,
} as any)
const AppRiskRoute = AppRiskRouteImport.update({
  id: '/risk',
  path: '/risk',
  getParentRoute: () => AppRoute,
} as any)
const AppRevenueRoute = AppRevenueRouteImport.update({
  id: '/revenue',
  path: '/revenue',
  getParentRoute: () => AppRoute,
} as any)
const AppReconciliationRoute = AppReconciliationRouteImport.update({
  id: '/reconciliation',
  path: '/reconciliation',
  getParentRoute: () => AppRoute,
} as any)
const AppPositionsRoute = AppPositionsRouteImport.update({
  id: '/positions',
  path: '/positions',
  getParentRoute: () => AppRoute,
} as any)
const AppPayoutsRoute = AppPayoutsRouteImport.update({
  id: '/payouts',
  path: '/payouts',
  getParentRoute: () => AppRoute,
} as any)
const AppOrganizationRoute = AppOrganizationRouteImport.update({
  id: '/organization',
  path: '/organization',
  getParentRoute: () => AppRoute,
} as any)
const AppInvitationsRoute = AppInvitationsRouteImport.update({
  id: '/invitations',
  path: '/invitations',
  getParentRoute: () => AppRoute,
} as any)
const AppHierarchyRoute = AppHierarchyRouteImport.update({
  id: '/hierarchy',
  path: '/hierarchy',
  getParentRoute: () => AppRoute,
} as any)
const AppFundingRoute = AppFundingRouteImport.update({
  id: '/funding',
  path: '/funding',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersIndexRoute = AppUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersIndexRoute = AppOrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => AppRoute,
} as any)
const AppFeesIndexRoute = AppFeesIndexRouteImport.update({
  id: '/fees/',
  path: '/fees/',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersAccountIdRoute = AppUsersAccountIdRouteImport.update({
  id: '/users/$accountId',
  path: '/users/$accountId',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersHistoryRoute = AppOrdersHistoryRouteImport.update({
  id: '/orders/history',
  path: '/orders/history',
  getParentRoute: () => AppRoute,
} as any)
const AppFeesPlansRoute = AppFeesPlansRouteImport.update({
  id: '/fees/plans',
  path: '/fees/plans',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/set-password': typeof SetPasswordRoute
  '/funding': typeof AppFundingRoute
  '/hierarchy': typeof AppHierarchyRoute
  '/invitations': typeof AppInvitationsRoute
  '/organization': typeof AppOrganizationRoute
  '/payouts': typeof AppPayoutsRoute
  '/positions': typeof AppPositionsRoute
  '/reconciliation': typeof AppReconciliationRoute
  '/revenue': typeof AppRevenueRoute
  '/risk': typeof AppRiskRoute
  '/security': typeof AppSecurityRoute
  '/settlement': typeof AppSettlementRoute
  '/staff': typeof AppStaffRoute
  '/statements': typeof AppStatementsRoute
  '/trades': typeof AppTradesRoute
  '/fees/plans': typeof AppFeesPlansRoute
  '/orders/history': typeof AppOrdersHistoryRoute
  '/users/$accountId': typeof AppUsersAccountIdRoute
  '/fees/': typeof AppFeesIndexRoute
  '/orders/': typeof AppOrdersIndexRoute
  '/users/': typeof AppUsersIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/set-password': typeof SetPasswordRoute
  '/funding': typeof AppFundingRoute
  '/hierarchy': typeof AppHierarchyRoute
  '/invitations': typeof AppInvitationsRoute
  '/organization': typeof AppOrganizationRoute
  '/payouts': typeof AppPayoutsRoute
  '/positions': typeof AppPositionsRoute
  '/reconciliation': typeof AppReconciliationRoute
  '/revenue': typeof AppRevenueRoute
  '/risk': typeof AppRiskRoute
  '/security': typeof AppSecurityRoute
  '/settlement': typeof AppSettlementRoute
  '/staff': typeof AppStaffRoute
  '/statements': typeof AppStatementsRoute
  '/trades': typeof AppTradesRoute
  '/': typeof AppIndexRoute
  '/fees/plans': typeof AppFeesPlansRoute
  '/orders/history': typeof AppOrdersHistoryRoute
  '/users/$accountId': typeof AppUsersAccountIdRoute
  '/fees': typeof AppFeesIndexRoute
  '/orders': typeof AppOrdersIndexRoute
  '/users': typeof AppUsersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/set-password': typeof SetPasswordRoute
  '/_app/funding': typeof AppFundingRoute
  '/_app/hierarchy': typeof AppHierarchyRoute
  '/_app/invitations': typeof AppInvitationsRoute
  '/_app/organization': typeof AppOrganizationRoute
  '/_app/payouts': typeof AppPayoutsRoute
  '/_app/positions': typeof AppPositionsRoute
  '/_app/reconciliation': typeof AppReconciliationRoute
  '/_app/revenue': typeof AppRevenueRoute
  '/_app/risk': typeof AppRiskRoute
  '/_app/security': typeof AppSecurityRoute
  '/_app/settlement': typeof AppSettlementRoute
  '/_app/staff': typeof AppStaffRoute
  '/_app/statements': typeof AppStatementsRoute
  '/_app/trades': typeof AppTradesRoute
  '/_app/': typeof AppIndexRoute
  '/_app/fees/plans': typeof AppFeesPlansRoute
  '/_app/orders/history': typeof AppOrdersHistoryRoute
  '/_app/users/$accountId': typeof AppUsersAccountIdRoute
  '/_app/fees/': typeof AppFeesIndexRoute
  '/_app/orders/': typeof AppOrdersIndexRoute
  '/_app/users/': typeof AppUsersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/reset-password'
    | '/set-password'
    | '/funding'
    | '/hierarchy'
    | '/invitations'
    | '/organization'
    | '/payouts'
    | '/positions'
    | '/reconciliation'
    | '/revenue'
    | '/risk'
    | '/security'
    | '/settlement'
    | '/staff'
    | '/statements'
    | '/trades'
    | '/fees/plans'
    | '/orders/history'
    | '/users/$accountId'
    | '/fees/'
    | '/orders/'
    | '/users/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/reset-password'
    | '/set-password'
    | '/funding'
    | '/hierarchy'
    | '/invitations'
    | '/organization'
    | '/payouts'
    | '/positions'
    | '/reconciliation'
    | '/revenue'
    | '/risk'
    | '/security'
    | '/settlement'
    | '/staff'
    | '/statements'
    | '/trades'
    | '/'
    | '/fees/plans'
    | '/orders/history'
    | '/users/$accountId'
    | '/fees'
    | '/orders'
    | '/users'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/reset-password'
    | '/set-password'
    | '/_app/funding'
    | '/_app/hierarchy'
    | '/_app/invitations'
    | '/_app/organization'
    | '/_app/payouts'
    | '/_app/positions'
    | '/_app/reconciliation'
    | '/_app/revenue'
    | '/_app/risk'
    | '/_app/security'
    | '/_app/settlement'
    | '/_app/staff'
    | '/_app/statements'
    | '/_app/trades'
    | '/_app/'
    | '/_app/fees/plans'
    | '/_app/orders/history'
    | '/_app/users/$accountId'
    | '/_app/fees/'
    | '/_app/orders/'
    | '/_app/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SetPasswordRoute: typeof SetPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/set-password': {
      id: '/set-password'
      path: '/set-password'
      fullPath: '/set-password'
      preLoaderRoute: typeof SetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/trades': {
      id: '/_app/trades'
      path: '/trades'
      fullPath: '/trades'
      preLoaderRoute: typeof AppTradesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/statements': {
      id: '/_app/statements'
      path: '/statements'
      fullPath: '/statements'
      preLoaderRoute: typeof AppStatementsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/staff': {
      id: '/_app/staff'
      path: '/staff'
      fullPath: '/staff'
      preLoaderRoute: typeof AppStaffRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settlement': {
      id: '/_app/settlement'
      path: '/settlement'
      fullPath: '/settlement'
      preLoaderRoute: typeof AppSettlementRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/security': {
      id: '/_app/security'
      path: '/security'
      fullPath: '/security'
      preLoaderRoute: typeof AppSecurityRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/risk': {
      id: '/_app/risk'
      path: '/risk'
      fullPath: '/risk'
      preLoaderRoute: typeof AppRiskRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/revenue': {
      id: '/_app/revenue'
      path: '/revenue'
      fullPath: '/revenue'
      preLoaderRoute: typeof AppRevenueRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reconciliation': {
      id: '/_app/reconciliation'
      path: '/reconciliation'
      fullPath: '/reconciliation'
      preLoaderRoute: typeof AppReconciliationRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/positions': {
      id: '/_app/positions'
      path: '/positions'
      fullPath: '/positions'
      preLoaderRoute: typeof AppPositionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/payouts': {
      id: '/_app/payouts'
      path: '/payouts'
      fullPath: '/payouts'
      preLoaderRoute: typeof AppPayoutsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/organization': {
      id: '/_app/organization'
      path: '/organization'
      fullPath: '/organization'
      preLoaderRoute: typeof AppOrganizationRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/invitations': {
      id: '/_app/invitations'
      path: '/invitations'
      fullPath: '/invitations'
      preLoaderRoute: typeof AppInvitationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/hierarchy': {
      id: '/_app/hierarchy'
      path: '/hierarchy'
      fullPath: '/hierarchy'
      preLoaderRoute: typeof AppHierarchyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/funding': {
      id: '/_app/funding'
      path: '/funding'
      fullPath: '/funding'
      preLoaderRoute: typeof AppFundingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users/': {
      id: '/_app/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AppUsersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders/': {
      id: '/_app/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof AppOrdersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/fees/': {
      id: '/_app/fees/'
      path: '/fees'
      fullPath: '/fees/'
      preLoaderRoute: typeof AppFeesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users/$accountId': {
      id: '/_app/users/$accountId'
      path: '/users/$accountId'
      fullPath: '/users/$accountId'
      preLoaderRoute: typeof AppUsersAccountIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders/history': {
      id: '/_app/orders/history'
      path: '/orders/history'
      fullPath: '/orders/history'
      preLoaderRoute: typeof AppOrdersHistoryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/fees/plans': {
      id: '/_app/fees/plans'
      path: '/fees/plans'
      fullPath: '/fees/plans'
      preLoaderRoute: typeof AppFeesPlansRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppFundingRoute: typeof AppFundingRoute
  AppHierarchyRoute: typeof AppHierarchyRoute
  AppInvitationsRoute: typeof AppInvitationsRoute
  AppOrganizationRoute: typeof AppOrganizationRoute
  AppPayoutsRoute: typeof AppPayoutsRoute
  AppPositionsRoute: typeof AppPositionsRoute
  AppReconciliationRoute: typeof AppReconciliationRoute
  AppRevenueRoute: typeof AppRevenueRoute
  AppRiskRoute: typeof AppRiskRoute
  AppSecurityRoute: typeof AppSecurityRoute
  AppSettlementRoute: typeof AppSettlementRoute
  AppStaffRoute: typeof AppStaffRoute
  AppStatementsRoute: typeof AppStatementsRoute
  AppTradesRoute: typeof AppTradesRoute
  AppIndexRoute: typeof AppIndexRoute
  AppFeesPlansRoute: typeof AppFeesPlansRoute
  AppOrdersHistoryRoute: typeof AppOrdersHistoryRoute
  AppUsersAccountIdRoute: typeof AppUsersAccountIdRoute
  AppFeesIndexRoute: typeof AppFeesIndexRoute
  AppOrdersIndexRoute: typeof AppOrdersIndexRoute
  AppUsersIndexRoute: typeof AppUsersIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppFundingRoute: AppFundingRoute,
  AppHierarchyRoute: AppHierarchyRoute,
  AppInvitationsRoute: AppInvitationsRoute,
  AppOrganizationRoute: AppOrganizationRoute,
  AppPayoutsRoute: AppPayoutsRoute,
  AppPositionsRoute: AppPositionsRoute,
  AppReconciliationRoute: AppReconciliationRoute,
  AppRevenueRoute: AppRevenueRoute,
  AppRiskRoute: AppRiskRoute,
  AppSecurityRoute: AppSecurityRoute,
  AppSettlementRoute: AppSettlementRoute,
  AppStaffRoute: AppStaffRoute,
  AppStatementsRoute: AppStatementsRoute,
  AppTradesRoute: AppTradesRoute,
  AppIndexRoute: AppIndexRoute,
  AppFeesPlansRoute: AppFeesPlansRoute,
  AppOrdersHistoryRoute: AppOrdersHistoryRoute,
  AppUsersAccountIdRoute: AppUsersAccountIdRoute,
  AppFeesIndexRoute: AppFeesIndexRoute,
  AppOrdersIndexRoute: AppOrdersIndexRoute,
  AppUsersIndexRoute: AppUsersIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SetPasswordRoute: SetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
